import { render, staticRenderFns } from "./ReportPreview.vue?vue&type=template&id=312a3a4e&scoped=true&"
import script from "./ReportPreview.vue?vue&type=script&lang=js&"
export * from "./ReportPreview.vue?vue&type=script&lang=js&"
import style0 from "./ReportPreview.vue?vue&type=style&index=0&id=312a3a4e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312a3a4e",
  null
  
)

export default component.exports